import Vue from 'vue'
import Vuex from 'vuex'
import persistedstate from './plugins/persistedState'
import select from './modules/select'
import pricingControl from './modules/pricingControl'
import notifications from './modules/notifications'
import triggerAction from './modules/triggerAction'
import frontendApplications from './modules/frontendApplications'
import kpiDashboard from './modules/kpiDashboard'
import { actions } from './actions'
import { mutations, UPDATE_TIMESTAMP } from './mutations'
import { state } from './initialState'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  state,
  mutations,
  getters,
  actions,
  plugins: [persistedstate],
  modules: {
    select,
    pricingControl,
    notifications,
    triggerAction,
    frontendApplications,
    kpiDashboard,
  },
  // Strict mode ensures that state is only mutated through mutation handlers
  // See more http://vuex.vuejs.org/en/strict.html
  strict: process.env.NODE_ENV !== 'production',
  // strict: false
})
export default store

setInterval(() => {
  store.commit(UPDATE_TIMESTAMP)
}, 1000)
